import type { IVocalise } from './vocalise';
import { vocaliseSchema } from './vocalise';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const PREPARED = 'VOCALISE/PREPARED';

export interface IPreparedAction {
  type: typeof PREPARED;
  payload: IVocalise;
}

export const preparedActionSchema = objectSchemaOf<IPreparedAction>({
  type: Joi.string().required().valid(PREPARED),
  payload: vocaliseSchema.required(),
});

export const prepared = actionCreator({
  type: PREPARED,
  schema: preparedActionSchema,
});
